import { IErrorState, NETWORK_ERR_CAT } from 'app/reducers/errorState/types';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ToastType } from 'shared-types/SharedTypes';
// for change accordionDetail
export const getAccordionDetail = (error: any) => {
  return error?.message || 'No error detail';
};

const initialState: IErrorState = {
  errorTitle: '',
  errorMessage: '',
  accordionTitle: '',
  errorSeverity: ToastType.error,
  accordionDetail: '',
  isErrorShowing: false,
  isOffline: false,
  errorCategory: '',
  extraButton: null,
  secondButton: null,
};
const errorStateSlice = createSlice({
  name: 'errorState',
  initialState,
  reducers: {
    setErrorState: (state: IErrorState, action: PayloadAction<IErrorState>) => {
      state.errorTitle = action.payload.errorTitle || 'Error';
      state.errorMessage = action.payload.errorMessage;
      state.accordionTitle = action.payload.accordionTitle || 'Error details';
      state.errorSeverity = action.payload.errorSeverity || ToastType.error;
      state.accordionDetail = action.payload.accordionDetail;
      state.isErrorShowing = action.payload.isErrorShowing || true;
      state.errorCategory = action.payload.errorCategory || '';
      state.extraButton = action.payload.extraButton || null;
      state.secondButton = action.payload.secondButton || null;
    },
    hideErrorState: (state: IErrorState) => {
      state.isErrorShowing = false;
      state.errorTitle = '';
      state.errorMessage = '';
      state.accordionTitle = '';
      state.accordionDetail = '';
      state.errorCategory = '';
      state.extraButton = null;
      state.secondButton = null;
    },
    setOfflineState: (state: IErrorState, action: PayloadAction<IErrorState>) => {
      /**
       * skip this if there is no existing offline status, so that it doesn't remove other categories of errors
       */
      if (!action.payload.isOffline && state.errorCategory !== NETWORK_ERR_CAT) {
        return;
      }
      state.isOffline = action.payload.isOffline;
      state.errorTitle = action.payload.errorTitle || 'Error';
      state.errorMessage = action.payload.errorMessage;
      state.accordionTitle = action.payload.accordionTitle || 'Error details';
      state.accordionDetail = action.payload.accordionDetail;
      state.errorCategory = NETWORK_ERR_CAT;
      state.isErrorShowing = false;
    },
  },
});
const { actions, reducer } = errorStateSlice;
export { actions as errorStateActions };
export default reducer;
